import { Badge, Divider, Stack, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import * as React from "react";
import { BsBell } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppApi } from "store/api-context";
import { ROUTES, screenNames } from "utils/constants/route.constants";
import useWindowDimension from "utils/hooks/use-dimension.hook";

export default function Notification({ styles }) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const open = Boolean(anchorEl);

  const { isMobile } = useWindowDimension();
  const isDivisionPage =
    pathname.includes("division") || pathname.includes("overview");

  const isHomePage = pathname === ROUTES.HOME;

  const {
    getAppPushNotifications,
    state: { alerts },
  } = useAppApi();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const getNavigationPath = (screeName) => {
    // TODO After implement done in BE, need to touch this
    switch (screeName) {
      case screenNames.signup:
        return `/auth/${ROUTES.REGISTER}`;

      case screenNames.signin:
        return "/auth/login";

      case screenNames.productsList:
        return "/our-shop/all?categoryId=ALL&query=";

      case screenNames.wishList:
        return ROUTES.WISH_LIST;

      case screenNames.cart:
        return ROUTES.CART;

      case screenNames.orders:
        return ROUTES.YOUR_ORDERS;

      default:
        return ROUTES.HOME;
    }
  };

  const handleNavigation = (screenName) => {
    const path = getNavigationPath(screenName);
    navigate(path);
  };

  React.useEffect(() => {
    getAppPushNotifications();
  }, []);

  return (
    <React.Fragment>
      <Box
        sx={{
          alignItems: "center",
          textAlign: "center",
          display: "flex",
          ...styles,
        }}
      >
        <Tooltip title="Notifications">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <Badge badgeContent={alerts?.length} color="error">
              <BsBell
                color={
                  isHomePage || isDivisionPage || isMobile
                    ? "#fff"
                    : "rgb(0, 64, 129)"
                }
              />
            </Badge>
          </IconButton>
        </Tooltip>
      </Box>
      {alerts?.length > 0 ? (
        <Menu
          sx={{
            overflowY: "scroll",
          }}
          anchorEl={anchorEl}
          id="notification-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflowY: "scroll",
              zIndex: 999,
              maxHeight: {
                xs: "220px",
                md: "440px",
              },
              width: "260px",
              overflow: "scroll",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              borderRadius: "8px",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
            },
          }}
        >
          {alerts?.map((alert, index) => (
            <>
              <MenuItem
                onClick={() => handleNavigation(alert?.navigation?.screenName)}
              >
                <Stack gap="4px">
                  <Typography
                    sx={{
                      fontWeight: 400,
                      lineHeight: "1.5",
                      margin: "0px 0px 0.35em",
                    }}
                  >
                    <b>{alert?.title}</b>
                  </Typography>
                  <Typography
                    sx={{
                      color: "rgb(62, 80, 96)",
                      margin: "0px 0px 0.35em",
                    }}
                  >
                    {alert?.body}
                  </Typography>
                </Stack>
              </MenuItem>
              {alerts?.length - 1 === index ? null : <Divider />}
            </>
          ))}
        </Menu>
      ) : null}
    </React.Fragment>
  );
}
